import React, { useEffect, useState, useMemo } from 'react';
import { useArticles } from '../contexts/ArticlesContext';
import { Paper, Typography, Container } from '@mui/material';
//import AddCircleIcon from '@mui/icons-material/AddCircle';
import Globe3D from '../components/Globe3D';
import '../styles/homepage.css';

const HomePage = () => {
    const { articles, fetchNextArticles } = useArticles();
    const [filteredArticles, setFilteredArticles] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isFetching, setIsFetching] = useState(false); // New state for fetch operations
    const [dimensions, setDimensions] = useState({
        width: Math.min(window.innerWidth * 0.9, 1200),
        height: window.innerWidth >= 960 ? // Check if desktop
        window.innerHeight * 0.65 : // Use 75% of viewport height on desktop
        window.innerHeight * 0.5    // Use 50% on mobile//- 64 - 150 -32//=articleinfobox minheight//Math.min(window.innerHeight * 0.5, 800)
    });
    const MAX_ARTICLES = 100;
    const [hasReachedLimit, setHasReachedLimit] = useState(false);

    // Memoize the markers array
    const markers = useMemo(() =>
        filteredArticles.map(article => ({
            lat: article.geoPoint.latitude,
            lng: article.geoPoint.longitude,
            title: article.title,
            TLDR: article.TLDR,
            pubDate: article.pubDate,
            link: article.link,
            id: article.id,
            insightfulCount: article.insightfulCount
        }))
        , [filteredArticles]);

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            setDimensions({
                width: Math.min(window.innerWidth * 0.9, 1200),
                height: window.innerWidth >= 960 ? // Check if desktop
        window.innerHeight * 0.65 : // Use 75% of viewport height on desktop
        window.innerHeight * 0.5    // Use 50% on mobile// - 64 -150 -32//height: Math.min(window.innerHeight * 0.5, 800)
            });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Load initial articles
    useEffect(() => {
        const loadAllArticles = async () => {
            // Check if we already have articles, to prevent loading them again when switching pages
            if (articles.length > 0) {
                setIsLoading(false);
                return;
            }
            setIsLoading(true);
            try {
                const result = await fetchNextArticles(50);
                console.log(`Initially loaded ${result?.length || 0} articles`);
            } catch (error) {
                console.error('Error loading initial articles:', error);
            } finally {
                setIsLoading(false);
            }
        };
        loadAllArticles();
    }, []); 

    // Filter articles whenever articles array changes
    useEffect(() => {
        const validArticles = articles.filter(article =>
            article.TLDR &&
            article.geoPoint &&
            !(article.geoPoint.latitude === 0 && article.geoPoint.longitude === 0)
        );

        setFilteredArticles(validArticles);
        console.table('Filtered articles:', validArticles);
        console.table('All articles:', articles);
    }, [articles]);

    const handleFetchMore = async (event) => {
        event.preventDefault();
        if (articles.length >= MAX_ARTICLES) {
            setHasReachedLimit(true);
            return;
        }

        try {
            setIsFetching(true);
            const result = await fetchNextArticles(25);
            if (articles.length + (result?.length || 0) >= MAX_ARTICLES) {
                setHasReachedLimit(true);
            }
            console.log(`Fetched ${result?.length || 0} new articles`);
        } catch (error) {
            console.error('Error fetching more articles:', error);
        } finally {
            setIsFetching(false);
        }
    };

    return (
        <Container 
            maxWidth={false} // Remove max width constraint
            disableGutters // Remove default padding
            sx={{ 
                minHeight: 'calc(100vh - 56px)',
                height: 'calc(100vh-56px)', // Set height to 100vh - appbar - paddings
                display: 'flex', 
                flexDirection: 'column',
                width: '100%', // Changed from 100vw to 100%
                overflow: 'hidden', // Add this to prevent scrolling
                margin: 0, // Remove default margins
                padding: 0, // Remove default padding
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    bgcolor: '#1a1a1a',
                    //p: 2,
                    mb: 0, // Remove bottom margin
                    borderRadius: 0, // Remove rounded corners
                    //minHeight: '100%', // Ensure full viewport height
                    width: '100%', // Add this to ensure Paper fills container
                boxSizing: 'border-box' // Add this to include padding in width calculation
                }}
            >
                {isLoading ? (
                    <Typography variant="h6" sx={{ color: 'white' }}>
                        Loading global climate news...
                    </Typography>
                ) : (
                    <Globe3D
                        width={dimensions.width}
                        height={dimensions.height}
                        markers={markers}
                        onLoadMore={handleFetchMore}
                        isLoading={isFetching}
                        hasReachedLimit={hasReachedLimit}
                    />
                )}
            </Paper>
        </Container>
    );
};

export default HomePage;